export const createArrayOfLength = (length: number) =>
  Array.from(Array(length));
